import axios from 'axios';
import { customAxios } from '../../common/customAxios';
import { myOwnTractorsApiUrl } from './getMyOwnTractors';

export const getMyOwnTractorImageExists = (): Promise<boolean> => {
  return customAxios.get(`${myOwnTractorsApiUrl}/image-exists`);
};
